'use strict';

var match = require('./match-state');

function toProtocolRelative(url) {
    return url.replace(/^https?:/, '').replace(/\/$/, '');
}

function doMatch(_ref) {
    var _ref$wwwSite = _ref.wwwSite,
        wwwSite = _ref$wwwSite === undefined ? 'http://www.finn.no' : _ref$wwwSite,
        _ref$source = _ref.source,
        source = _ref$source === undefined ? 'mfinn' : _ref$source;

    var url = toProtocolRelative(wwwSite + '/distribution-front/c/match?source=' + source);
    var i = document.createElement('iframe');
    i.setAttribute('src', url);
    i.setAttribute('id', 'matchframe');
    i.style.display = 'none';
    document.body.appendChild(i);
    match.setMatched();
    return true;
}

module.exports = function cookieMatch(options) {
    if (match.notMatchedYet()) {
        return doMatch(options);
    }
    return false;
};
//# sourceMappingURL=index.js.map